window.addEventListener('load', (event) => {
    if (isCMSMode()) {
        document.querySelector('body').classList.add('isCMSMode');
    }
});


function isCMSMode() {
    return (window.location !== window.parent.location);
}

module.exports = isCMSMode;
